import {useQuery} from "@tanstack/react-query";
import {useMemo} from "react";

import {useStoredMe} from "@/src/modules/core/store/me";

import {HELP_STALE_TIME_MS} from "../lib/help-cache";
import {helpService} from "../services";

export default function useScreenHelp(domain: string, screen: string, enabled = true) {
  const me = useStoredMe();
  const userId = me?.user_id ?? 0;

  const query = useQuery({
    queryKey: ["help", "fields", userId, domain, screen],
    queryFn: () => helpService.getFieldsByScreen(userId, domain, screen),
    enabled: enabled && userId > 0 && Boolean(domain) && Boolean(screen),
    staleTime: HELP_STALE_TIME_MS,
    retry: false,
  });

  const fieldsByKey = useMemo(
    () => helpService.fieldsToMap(query.data?.fields ?? []),
    [query.data?.fields],
  );

  return {
    ...query,
    fields: query.data?.fields ?? [],
    fieldsByKey,
  };
}
